import { Journey } from "@/types/*";
import { extractResource } from "../../../../helper/extractResource";

export const displayCheckinMessage = (journeys: Journey[], resourceData: Record<string, string>) => {
  if (journeys?.length === 1) {
    return extractResource(resourceData, "ONEWAY_CHECKIN");
  }
  if (journeys?.length === 2) {
    const isRoundTrip =
      journeys[0]?.designator?.destination === journeys[1]?.designator?.origin &&
      journeys[0]?.designator?.origin === journeys[1]?.designator?.destination;

    return isRoundTrip
      ? extractResource(resourceData, "ROUNDTRIP_CHECKIN")
      : extractResource(resourceData, "MULTICITY_CHECKIN");
  }
  return extractResource(resourceData, "MULTICITY_CHECKIN");
};
